export enum BotButtonPayloadType {
  ShareCard = 'button.payload.share.card',
  OpenUrl = 'button.payload.open.url',
  Command = 'button.payload.command',
}
